"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./FormCheckboxControl.scss");
var __1 = require("../../");
var FormCheckboxControl = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? null : _b, dusk = _a.dusk, errors = _a.errors, _c = _a.flush, flush = _c === void 0 ? false : _c, _d = _a.help, help = _d === void 0 ? null : _d, htmlFor = _a.htmlFor, _e = _a.label, label = _e === void 0 ? null : _e;
    var classes = [
        'form-checkbox-control flex',
        flush ? 'form-checkbox-control--flush' : '',
        className,
    ];
    return (react_1.default.createElement("div", { "data-dusk": dusk, className: classnames_1.default.apply(void 0, classes) },
        react_1.default.createElement("div", { className: "form-checkbox-control--checkbox" }, children),
        react_1.default.createElement("div", { className: "pl-4 inline-block leading-none" },
            label && react_1.default.createElement(__1.FormLabel, { htmlFor: htmlFor, label: label }),
            help && react_1.default.createElement("p", { className: "text-sm text-gray mb-0 leading-snug" }, help),
            errors && react_1.default.createElement(__1.FormError, { errors: errors }))));
};
exports.default = FormCheckboxControl;
//# sourceMappingURL=index.js.map